(()=>{
  const one=(s,r=document)=>r.querySelector(s);
  const all=(s,r=document)=>Array.from(r.querySelectorAll(s));
  const esc=(v)=>String(v||'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  function init(root){
    if(root.dataset.sovrReady==='1') return;
    root.dataset.sovrReady='1';

    const menu=one('[data-menu]',root);
    const search=one('[data-search]',root);
    const cart=one('[data-cart]',root);
    const shade=one('[data-shade]',root);
    const menuBtn=one('[data-menu-btn]',root);
    const searchBtn=one('[data-search-btn]',root);
    const cartBtn=one('[data-cart-btn]',root);
    const closeCart=one('[data-close-cart]',root);
    const items=one('[data-items]',root);
    const empty=one('[data-empty]',root);
    const footer=one('[data-footer]',root);
    const dot=one('[data-cart-dot]',root);
    const total=one('[data-total]',root);
    const note=one('[data-note]',root);
    const checkout=one('[data-checkout]',root);
    const login=one('.sovr-h__login',root);
    const base=(root.dataset.root||'/').replace(/\/?$/,'/');
    const currency=root.dataset.currency||'USD';
    let lastTrigger=null;
    let noteTimer;

    if(login){
      const label=/account/i.test(login.textContent)?'ACCOUNT':'LOGIN';
      login.innerHTML='<svg viewBox="0 0 32 32" aria-hidden="true"><circle cx="16" cy="10.5" r="5.5"/><path d="M6.5 27c.8-6.1 4.4-9.2 9.5-9.2s8.7 3.1 9.5 9.2"/></svg><span>'+label+'</span>';
    }

    const money=(cents)=>{
      try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency}).format(Number(cents||0)/100)}
      catch(e){return '$'+(Number(cents||0)/100).toFixed(2)}
    };

    const panel=(el,isOpen)=>{
      if(!el) return;
      el.classList.toggle('open',isOpen);
      el.setAttribute('aria-hidden',String(!isOpen));
    };

    function closePanels(restore=true){
      panel(menu,false); panel(search,false); panel(cart,false);
      menuBtn?.setAttribute('aria-expanded','false');
      shade?.classList.remove('on');
      setTimeout(()=>{if(shade) shade.hidden=true},250);
      document.documentElement.classList.remove('sovr-lock');
      if(restore) lastTrigger?.focus();
    }

    function render(data){
      const cartItems=Array.isArray(data?.items)?data.items:[];
      const hasItems=cartItems.length>0;
      if(dot) dot.hidden=Number(data?.item_count||0)===0;
      if(empty){empty.hidden=hasItems;empty.textContent='Your cart is empty';}
      if(footer) footer.hidden=!hasItems;
      if(total) total.textContent=money(data?.total_price||0);
      if(note&&document.activeElement!==note) note.value=data?.note||'';
      if(!items) return;

      items.innerHTML=cartItems.map((item,index)=>{
        const src=item.image?item.image+(item.image.includes('?')?'&':'?')+'width=320':'';
        const image=src?'<img src="'+esc(src)+'" alt="'+esc(item.product_title)+'" loading="lazy">':'';
        const variant=item.variant_title&&item.variant_title!=='Default Title'?'<div class="sovr-ci__variant">'+esc(item.variant_title)+'</div>':'';
        return '<article class="sovr-ci" data-line="'+(index+1)+'">'+
          '<a class="sovr-ci__img" href="'+esc(item.url)+'">'+image+'</a>'+
          '<div class="sovr-ci__details">'+
            '<a class="sovr-ci__title" href="'+esc(item.url)+'">'+esc(item.product_title)+'</a>'+variant+
            '<div class="sovr-ci__price">'+money(item.final_line_price)+'</div>'+
            '<div class="sovr-ci__controls">'+
              '<div class="sovr-qty"><button type="button" data-act="minus" aria-label="Decrease quantity">−</button><span>'+Number(item.quantity||1)+'</span><button type="button" data-act="plus" aria-label="Increase quantity">+</button></div>'+
              '<button type="button" class="sovr-remove" data-act="remove" aria-label="Remove item">Remove</button>'+
            '</div>'+
          '</div>'+
        '</article>';
      }).join('');
    }

    async function loadCart(){
      if(empty){empty.hidden=false;empty.textContent='Loading cart…';}
      try{
        const response=await fetch(base+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
        if(!response.ok) throw new Error('Cart request failed '+response.status);
        render(await response.json());
      }catch(error){
        console.error('[SOVRCLUB cart]',error);
        if(empty){empty.hidden=false;empty.textContent='Unable to load cart. Refresh and try again.';}
        if(footer) footer.hidden=true;
      }
    }

    async function changeCart(line,quantity){
      try{
        const response=await fetch(base+'cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line,quantity})});
        if(!response.ok) throw new Error('Cart update failed '+response.status);
        render(await response.json());
      }catch(error){
        console.error('[SOVRCLUB cart]',error);
        loadCart();
      }
    }

    function openPanel(type,trigger){
      closePanels(false);
      lastTrigger=trigger;
      document.documentElement.classList.add('sovr-lock');
      if(shade){shade.hidden=false;requestAnimationFrame(()=>shade.classList.add('on'));}
      if(type==='menu'){panel(menu,true);menuBtn?.setAttribute('aria-expanded','true');}
      if(type==='search'){panel(search,true);setTimeout(()=>one('[data-search-input]',root)?.focus(),100);}
      if(type==='cart'){panel(cart,true);loadCart();}
    }

    menuBtn?.addEventListener('click',()=>menu?.classList.contains('open')?closePanels():openPanel('menu',menuBtn));
    searchBtn?.addEventListener('click',()=>search?.classList.contains('open')?closePanels():openPanel('search',searchBtn));
    cartBtn?.addEventListener('click',()=>openPanel('cart',cartBtn));
    closeCart?.addEventListener('click',()=>closePanels());
    shade?.addEventListener('click',()=>closePanels());

    items?.addEventListener('click',(event)=>{
      const button=event.target.closest('[data-act]');
      if(!button) return;
      const row=button.closest('[data-line]');
      if(!row) return;
      const line=Number(row.dataset.line);
      const current=Number(one('.sovr-qty span',row)?.textContent||1);
      const quantity=button.dataset.act==='plus'?current+1:button.dataset.act==='minus'?Math.max(0,current-1):0;
      changeCart(line,quantity);
    });

    note?.addEventListener('input',()=>{
      clearTimeout(noteTimer);
      noteTimer=setTimeout(()=>fetch(base+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:note.value})}),450);
    });

    checkout?.addEventListener('click',()=>location.href=base+'checkout');
    document.addEventListener('keydown',e=>{if(e.key==='Escape') closePanels();});
    document.addEventListener('submit',e=>{if(e.target?.action?.includes('/cart/add')) setTimeout(loadCart,650);},true);
    ['cart:refresh','cart:updated','product:added'].forEach(name=>document.addEventListener(name,loadCart));
    loadCart();
  }

  function boot(){all('[data-sovr-header]').forEach(init);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',event=>{
    const root=event.target.querySelector?.('[data-sovr-header]')||event.target.closest?.('[data-sovr-header]');
    if(root){delete root.dataset.sovrReady;init(root);}else boot();
  });
})();

(()=>{
  function initOverlay(root){
    if(root.dataset.overlayReady) return;
    const editorial=document.querySelector('.section-sovrclub-editorial');
    const clean=p=>(p||'/').replace(/\/+$/,'')||'/';
    if(!editorial||clean(location.pathname)!==clean(root.dataset.root||'/')) return;
    root.dataset.overlayReady='1';
    root.classList.add('sovr-h--home-overlay');
    const syncScroll=()=>root.classList.toggle('sovr-h--scrolled',window.scrollY>8);
    const syncPanel=()=>root.classList.toggle('sovr-h--panel-open',!!root.querySelector('.sovr-h__menu.open,.sovr-h__search.open,.sovr-h__cart.open'));
    syncScroll();syncPanel();
    window.addEventListener('scroll',syncScroll,{passive:true});
    new MutationObserver(syncPanel).observe(root,{subtree:true,attributes:true,attributeFilter:['class']});
  }
  const boot=()=>document.querySelectorAll('[data-sovr-header]').forEach(initOverlay);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();

(()=>{
  const id='sovr-menu-reference-style';
  document.getElementById(id)?.remove();
  const style=document.createElement('style');
  style.id=id;
  style.textContent='.sovr-h__shade{background:rgba(0,0,0,.08)!important}.sovr-h__menu{background:rgba(0,0,0,.76)!important;padding:12px 32px max(28px,env(safe-area-inset-bottom))!important;display:flex!important;flex-direction:column!important}.sovr-h__menu nav{width:100%!important}.sovr-h__menu nav>a,.sovr-h__menu summary{min-height:84px!important;padding:0!important;border-bottom:1px solid rgba(255,255,255,.86)!important;color:#fff!important;font-size:16px!important;font-weight:400!important;letter-spacing:.035em!important}.sovr-h__menu details>div{border-bottom:1px solid rgba(255,255,255,.86)!important;padding:8px 0 14px!important}.sovr-h__menu details a{font-size:14px!important;padding:12px 0 12px 14px!important}.sovr-h__login{margin-top:auto!important;padding:26px 0 8px!important;color:#fff!important;font-size:14px!important}@media(max-width:749px){.sovr-h__menu{top:var(--h)!important;bottom:0!important;overflow-y:auto!important}}';
  document.head.appendChild(style);
})();